import './loader.css'

const CardLoader = () => {

    return (
        <div className="card-loader"></div>
    )
}

export default CardLoader;